import { concatHex, keccak256, stringToHex, type Address, type Hex } from 'viem';

/**
 * The account hash a wallet-only (EOA) Snappy account is created with:
 * `keccak256('eoa:' || owner)`. It carries no chain component, so the same
 * owner produces the same hash on Cronos and HyperEVM.
 *
 * Must stay byte-identical to `eoaBootstrapHash` in MoonHub.API
 * (`common/trading-session.ts`) and RustSigner (`src/trading_session.rs`).
 */
export function eoaBootstrapHash(owner: Address): Hex {
    return keccak256(concatHex([stringToHex('eoa:'), owner]));
}
